import { render, staticRenderFns } from "./CourseCardAboutInstructor.vue?vue&type=template&id=b0686cd2&scoped=true"
import script from "./CourseCardAboutInstructor.vue?vue&type=script&lang=js"
export * from "./CourseCardAboutInstructor.vue?vue&type=script&lang=js"
import style0 from "./CourseCardAboutInstructor.vue?vue&type=style&index=0&id=b0686cd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0686cd2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListIcon: require('/builds/marketing/abstracta.academy-website/components/ListIcon.vue').default,Accordion: require('/builds/marketing/abstracta.academy-website/components/Accordion.vue').default})
